import { useCustomUpdateDailyFormVehicleServicePlanMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateDailyFormVehicleServicePlan() {
  const [mutation, { loading, data, error }] = useCustomUpdateDailyFormVehicleServicePlanMutation();

  const [updateDailyFormVehicleServicePlan, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateDailyFormVehicleServicePlan",
    },
    { hideMessage: true }
  );

  return [updateDailyFormVehicleServicePlan, context] as const;
}
